module.exports = __webpack_public_path__ + "img/photo_placeholder-candidate.8ef32882.jpg";